import { Component, OnInit, ViewChild } from '@angular/core';
import {
  AuthService,
  DataService,
  ToasterService,
} from '../../shared/services';
import { Router } from '@angular/router';
import { GridOptions } from 'ag-grid-community';
import { TranslateService } from '@ngx-translate/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ConfResponsibleGroupsModel } from '../../shared/models';
import { ConfirmModalComponent } from '../../shared/modals';
import { GridComponent } from '../../shared';
import { ResponsibleGroupsEditComponent } from './edit/edit.component';

import * as _ from 'lodash';

import { BreadCrumbService } from '../../shared/services/breadcrumb.service';

@Component({
  selector: 'app-responsible-groups',
  templateUrl: './responsible-groups.component.html',
})
export class ResponsibleGroupsComponent implements OnInit {
  @ViewChild(GridComponent, { static: true })
  confResponsibleGroupsGrid?: GridComponent;

  // Available items
  items: any[] = [];
  selectedNodes: any[] = [];
  parentFiltered?: any;
  // UI flag
  isLoading = false;
  // Local grid options
  gridOptions?: GridOptions;
  // Modal ref pointer
  bsModalRef?: BsModalRef;

  constructor(
    private translate: TranslateService,
    private data: DataService,
    private bsModalService: BsModalService,
    private toastr: ToasterService,
    public auth: AuthService,
    public router: Router,
    public breadCrumbService: BreadCrumbService
  ) {}

  /**
   */
  async ngOnInit(): Promise<void> {
    this.breadCrumbService.set(
      [
        {
          name: this.translate.instant('navigations.breadcrumbs.modules'),
          link: '/modules',
        },
        {
          name: this.translate.instant(
            'navigations.breadcrumbs.responsible_groups'
          ),
          link: '/responsible-groups',
        },
      ],
      2
    );
    this.gridOptions = {
      getRowId: (row: any) => row.data.id,
      suppressRowClickSelection: true,
      rowSelection: 'multiple',
      rowHeight: 30,
      headerHeight: 30,
      animateRows: true,
      floatingFiltersHeight: 30,
      enableCellTextSelection: false,
      suppressContextMenu: true,
      defaultColDef: {
        filter: true,
        sortable: true,
        resizable: true,
        floatingFilter: true,
      },
      columnDefs: [
        {
          headerName: this.translate.instant('headers.responsible_group.name'),
          field: 'description',
          checkboxSelection: true,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          filter: 'agTextColumnFilter',
        },
        {
          headerName: this.translate.instant('headers.responsible_group.type'),
          field: 'type',
          cellRenderer: this.typeRenderer,
          filterParams: {
            valueFormatter: this.valueFormatter,
          },
        },
      ],
    };
    await this.loadItems();
  }

  typeRenderer = (params: any): string => {
    if (params.value) {
      return this.translate.instant(
        'headers.responsible_group.type_' + params.value
      );
    }
    return '';
  };

  valueFormatter = (params: any): string => {
    return this.translate.instant(
      'headers.responsible_group.type_' + params.value
    );
  };

  /**
   */
  async loadItems(silent = false): Promise<void> {
    if (!silent) {
      this.isLoading = true;
    }
    this.items = await this.data
      .by('api/config/responsible_groups', {
        criteria: {
          site: this.auth.getSiteId(),
        },
      })
      .toPromise();
    this.confResponsibleGroupsGrid?.gridApi?.sizeColumnsToFit();
    this.confResponsibleGroupsGrid?.uncheckAll();
    if (!silent) {
      this.isLoading = false;
    }
  }

  onFilterChanged(event: any): void {}

  onSelectionChanged(event: any): void {
    this.selectedNodes = event;
  }

  onRowClicked(event: any): void {
    this.showEditModal([new ConfResponsibleGroupsModel(event)]);
  }

  /**
   * @param items
   */
  async showEditModal(items?: ConfResponsibleGroupsModel[]): Promise<void> {
    this.bsModalRef = this.bsModalService.show(ResponsibleGroupsEditComponent, {
      initialState: {
        items,
      },
    });
    this.bsModalRef.content.confirmFn = () => {
      this.loadItems();
      this.toastr.showSuccess();
    };
  }

  /**
   */
  showMassDeleteConfirm(): void {
    this.bsModalRef = this.bsModalService.show(ConfirmModalComponent, {
      initialState: {
        title: 'navigations.delete',
        content: '',
      },
    });
    this.bsModalRef.content.confirmFn = () => {
      const ids = _.map(this.selectedNodes, (el) => el.id);
      this.data.post('api/config/responsible_groups/delete-all', ids).subscribe(
        (res) => {
          this.loadItems();
          this.toastr.showSuccess('messages.delete');
        },
        (err) => {
          this.toastr.showError();
        }
      );
      this.bsModalRef?.hide();
    };
    this.bsModalRef.content.cancelFn = () => {
      this.bsModalRef?.hide();
    };
  }

  myCellCallback = (params: any) => {
    return params.value;
  };
}
